

import templatePop from '../views/studentpopup-list.html';
class myCumulativeReport {
    constructor($scope, $state, $stateParams, $sce, $rootScope,
        authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS, $mdMedia, $mdDialog) {
        'ngInject';
        let self = this
        $rootScope.title = "Cumulative Report"
        $scope.loading = true
        self.typeArray = undefined
        self.levelArray = undefined
        self.resPerTheme = undefined
        self.tagArr = undefined
        self.data_set = undefined
        self.header = undefined
        self.perTypeObj = {}
        self.perTagObj = {}
        self.perLevelObj = {}
        self.themeTotal = undefined
        self.no_of_students = undefined
        self.allThemeTotal = {}
        self.noData = true
        $scope.view_only = false
        $scope.filterObj = {}
        self.noAcademics = true
        let myUserId = localStorageService.get('user_id')
        let activeAcd = localStorageService.get('academic_year')
        let school_id = localStorageService.get('school_id')
        let thisSchoolId = school_id
        let filterThru = localStorageService.get('can_filter')
        if (filterThru == "true") {
            filterThru = true
        } else {
            filterThru = undefined
        }
        var insideCourseware = false
        let LEVEL_ARRAY = [{
            level: "1",
            alias: "Easy"
        }, {
            level: "2",
            alias: "Medium"
        }, {
            level: "3",
            alias: "Difficult"
        }]
        //Boolean - To set view for fetch
        $scope.isFilter = true;

        //Object - Holds selection data
        $scope.selectAcademics = {};

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Cumulative Report"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            getSession()
        }


        function getSession() {
            $scope.toSearchObj = {
                user_id: myUserId,
                school_id: school_id,
                academic_year: activeAcd,
                exam: {
                    $exists: 1
                }
            }
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.sessions = response.result.data.details;
                        $scope.selectAcademics.session = undefined;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.curriculums = [];
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                        $scope.loading = false;
                    } catch (ex) {
                        console.log(ex)
                    }
                } else {
                    $scope.loading = false
                    toastr.error('Network Error. Please try later')
                }
                _.defer(function () {
                    $scope.$apply();
                });
            })
        }

        $scope.getCuriculum = (session) => {
            $scope.selectAcademics.session = session;
            $scope.toSearchObj.session = $scope.selectAcademics.session._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.curriculums = response.result.data.details;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getClass = (curriculum) => {
            $scope.selectAcademics.curriculum = curriculum;
            $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CLASS_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.classes = response.result.data.details;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.batches = [];
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getBatch = (xclass) => {
            $scope.selectAcademics.class = xclass;
            $scope.toSearchObj.class = $scope.selectAcademics.class._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_BATCH_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.batches = response.result.data.details;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getSubject = (batch) => {
            $scope.selectAcademics.batch = batch;
            $scope.toSearchObj.batch = $scope.selectAcademics.batch._id;
            $scope.getStudents($scope.toSearchObj)
            // authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SUBJECT_DETAILS, "POST", $scope.toSearchObj, function (response) {
            //     if (response.result && response.result.data && response.result.data.details) {
            //         try {
            //             $scope.subjects = response.result.data.details;
            //             $scope.selectAcademics.subject = undefined;
            //         } catch (ex) {
            //             console.log(ex);
            //         }
            //     } else {
            //         toastr.error('Network Error. Please try later');
            //     }
            //     _.defer(function () {
            //         $scope.$apply();
            //     });
            // });
        }
        // $scope.fetchReport = function (subject) {
        //     $scope.selectAcademics.subject = subject;
        //     $scope.selectedAcademics = angular.copy($scope.selectAcademics);
        //     $scope.toSearchObj.subject = $scope.selectAcademics.subject._id;
        //     $scope.getStudents($scope.toSearchObj)
        // }

        $scope.getStudents = (toSearchObj) => {
            console.log(toSearchObj)
            if (toSearchObj) {
                console.log(toSearchObj)
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    template: templatePop,
                    controller: ['$scope', '$mdDialog', "toSearchObj", "authService", 'parentScopeObj',
                        'localStorageService', StudentsCtrl],
                    parent: angular.element(document.body),
                    locals: {
                        toSearchObj: toSearchObj,
                        parentScopeObj: $scope,
                        authService: authService,
                        localStorageService: localStorageService
                    },
                    clickOutsideToClose: true,
                    fullscreen: true
                })
                    .then(function () {

                    }, function () {
                        $scope.status = 'You cancelled the dialog.';
                    });
            }
        }
        $scope.uCanTrust = function (obj) {
            // string = "<span style='color: #89a000'>123</span>"
            if (obj && obj.color) {
                let color = obj.color['background-color']
                let string = '<span class="td-color" style="background-color:' + color + ';">' + obj.score + '</span>';
                return $sce.trustAsHtml(string);
            }

        }
        $scope.getStudentReport = (academics, user_id) => {
            $scope.loading = true
            let send = {
                "curriculumId":academics.curriculum_id,
                "sessionId":academics.session_id, 
                "schoolId":academics.school_id, 
                "pdfFlag":"false",
                "myUserId" : myUserId,
                "acdYear": activeAcd,
                "studentId":user_id,
                "student_id":user_id,
                "FILE_UPLOAD_URL": CONSTANTS.FILE_UPLOAD_URL
            }
            authService.callAPI("/v0/educore_reports/cumulative", "POST",
                { args: send }, function (resp) {
                    try{
                        if (!resp.error) {
                            let result = resp.result.data.details
                            console.log(result)
                            if(result.scholasticSubjects.length || result.extraSubjectArray.length){
                                self.noData = false
                            }
                            self.scholasticSubjects = result.scholasticSubjects
                            self.subject_report = result.subject_report
                            self.reportCardConsoleDetails = result.reportCardConsoleDetails
                            self.returnArray = result.returnArray
                            self.relationValue = result.relationValue
                            self.overallAcg = result.overallAcg
                            self.classAvg = result.classAvg
                            self.extraSubjectArray = result.extraSubjectArray
                            self.extraSubjectData = result.extraSubjectData
                            self.header = result.header
                            $scope.urls =  result.pdf_url
                            $scope.loading = false
                            $scope.$apply()
                        }else{
                            self.noData = true
                        }
                        $scope.loading = false
                        $scope.$apply();
                    }catch(e){
                        $scope.loading = false
                        console.log(e)
                    }
                });
        }



        self.export = () => {
            $scope.isPdfData = true
            $scope.url = $sce.trustAsResourceUrl($scope.urls)
            _.defer(function() { $scope.$apply(); });;
        }
        self.backToHtml = () => {
            $scope.isPdfData = false
        }

    }
}
Array.prototype.sum = function (prop) {
    var total = 0
    for ( var i = 0, _len = this.length; i < _len; i++ ) {
        total += this[i][prop]
    }
    return total
}
class StudentsCtrl {
    constructor($scope, $mdDialog, toSearchObj, authService, parentScopeObj,
        localStorageService) {
        let send = {
            session_id: toSearchObj.session,
            curriculum_id: toSearchObj.curriculum,
            class_id: toSearchObj.class,
            batch_id: toSearchObj.batch,
            subject_id: toSearchObj.subject ? toSearchObj.subject : undefined,
            school_id: toSearchObj.school_id,
        }
        authService.callAPI("/v0/educore_reports/student/list", "POST",
            { args: send }, function (response) {
                if (!response.error) {
                    let res = response.result.data.details
                    $scope.studentList = res;
                    $scope.$apply();
                }
            });
        $scope.gotoStudentSubjectReport = (user_id) => {
            $mdDialog.hide()
            parentScopeObj.getStudentReport(send, user_id)
        }
        $scope.cancel = function() {
            $mdDialog.cancel()
        }
    }
}
export default myCumulativeReport;


// WEBPACK FOOTER //
// ./src/app/educore_reports/cumulative/controllers/controller.js